// extracted by mini-css-extract-plugin
export var divider = "styles-module--divider--UHjGj";
export var dividerTransparent = "styles-module--dividerTransparent--KWqBO";
export var footer = "styles-module--footer--IF1CV";
export var footerContainer = "styles-module--footerContainer--skK7T";
export var footerContent = "styles-module--footerContent--58haZ";
export var madeBy = "styles-module--madeBy--W0F-J";
export var separationOne = "styles-module--separationOne--CmkuW";